;$(function() {

	page = {};
	page.button = {};
	page.button.showMap = $('.contact-show-map');

	action = {};
	action.findMap = button => {
		return button.parents('.contact').eq(0).children('.contact__map');
	}
	action.initMap = map => {
		let coords = map.prev().data('coords').split(',').map(i => parseFloat(i));

		let dealer = {};
		dealer.name = map.prev().find('.address-card__heading').text();
		dealer.phone = map.prev().find('.address-card__text').children('span').eq(1).html().slice(9);
		dealer.address = map.prev().find('.address-card__text').children('span').eq(0).html();

		var dealerMap = new ymaps.Map(map[0], {
			center: coords,
			zoom: 14,
			controls: ['zoomControl']
		});

		dealerMap.behaviors.disable('scrollZoom');

		var Placemark = new ymaps.Placemark(coords, {}, {
			iconLayout: 'default#image',
			iconImageHref: '/static/images/icon-placeholder.svg',
			iconImageSize: [20, 30],
			iconImageOffset: [-10, -15],
			balloonContentLayout: ymaps.templateLayoutFactory.createClass(
				'<div>'+
					'<p>' + dealer.name + '</p>' +
					dealer.phone +
					'<p>' + dealer.address + '</p>' +
				'</div>'
			)
		});

		dealerMap.geoObjects.add(Placemark);
	}
	action.button = {};
	action.button.showMap = {};
	action.button.showMap.onClick = function() {
		let map = action.findMap($(this));

		if (map.css('display') == 'block')
			map.slideUp();
		else {
			map.slideDown(400, ()=>{
				if (map.html() == '')
					action.initMap(map);
			});
		}
	}

	page.button.showMap.click( action.button.showMap.onClick );

})